import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation UpdatePushTokenWeb($id: ID!, $pushTokenWeb: String) {
    updatePushTokenWeb(id: $id, pushTokenWeb: $pushTokenWeb) {
      id
    }
  }
`);
